import { render, staticRenderFns } from "./cly-datatable.vue?vue&type=template&id=1e664bb1"
import script from "./cly-datatable.vue?vue&type=script&lang=js"
export * from "./cly-datatable.vue?vue&type=script&lang=js"
import style0 from "./cly-datatable.vue?vue&type=style&index=0&id=1e664bb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports